<div class="flex overflow-x-auto gap-2 px-4 py-2 md:flex-wrap">
  @for (filter of quickFilters; track filter.id) {
    <div [attr.data-theme]="filterActiveStates().get(filter.id) ? 'b2b-dark' : null">
      <lds-button [variant]="ButtonVariant.SECONDARY" [size]="Size.MD" (clicked)="onToggleFilter(filter)">
        @if (filter.filterType !== 'loyaltyPrograms') {
          {{ filter.translationKey | translate }}
        } @else {
          {{ loyaltyProgramData().name | translate }}
        }
      </lds-button>
    </div>
  }
</div>
